import React from "react";
import classNames from "classnames";
import "./ThemeSwitcher.scss";

const ThemeSwitcher = (props) => {
  let switchClassName = classNames({
    switch: true,
  });

  let sliderClassName = classNames({
    slider: true,
    round: true,
  });

  return (
    <label id="switch" className={switchClassName}>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={props.onChange}
        id="slider"
      ></input>
      <span className={sliderClassName}></span>
    </label>
  );
};

export default ThemeSwitcher;
